export const getPricingOfAccountWhatsappCampaign = {
  GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST: "GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST",
  GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_SUCCESS: "GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_SUCCESS",
  GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_ERROR: "GET_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_ERROR",
};

export const editPricingOfAccountWhatsappCampaign = {
  EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST: "EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_REQUEST",
  EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_SUCCESS: "EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_SUCCESS",
  EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_ERROR: "EDIT_PRICING_OF_ACCOUNT_WHATSAPP_CAMPAIGN_ERROR",
};


export const getPricingOfAccountWhatsapp2Campaign = {
  REQUEST: 'GET_PRICING_OF_ACCOUNT_WHATSAPP_2_CAMPAIGN_REQUEST',
  SUCCESS: 'GET_PRICING_OF_ACCOUNT_WHATSAPP_2_CAMPAIGN_SUCCESS',
  ERROR: 'GET_PRICING_OF_ACCOUNT_WHATSAPP_2_CAMPAIGN_ERROR',
};

export const editPricingOfAccountWhatsapp2Campaign = {
  REQUEST: 'EDIT_PRICING_OF_ACCOUNT_WHATSAPP_2_CAMPAIGN_REQUEST',
  SUCCESS: 'EDIT_PRICING_OF_ACCOUNT_WHATSAPP_2_CAMPAIGN_SUCCESS',
  ERROR: 'EDIT_PRICING_OF_ACCOUNT_WHATSAPP_2_CAMPAIGN_ERROR',
};
